// extracted by mini-css-extract-plugin
export default {"formContainer":"UserForm_formContainer__Mw10d"};